// extracted by mini-css-extract-plugin
export default {"tabButton":"Transaction_tabButton__yIS5p","selected":"Transaction_selected__0UnFU"};